<span
  class="chip"
  [class.selected]="selected"
  [class.intern-list]="variant === 'intern-list'"
  (click)="fnChipClick()"
>
  {{ item?.text || item?.label }}

  <img
    src="./assets/icons/close-without-bg.svg"
    alt="Close"
    *ngIf="removeItem"
    (click)="$event.stopPropagation(); fnRemoveItem(item.id)"
  />
</span>